import { STRAPI_API_TOKEN } from 'config';
import { strapiClient } from '..';
import { TTranslatesResponse } from 'common/types/translations';

export const fetchTranslates = async (): Promise<TTranslatesResponse> => {
  const { data } = await strapiClient.get(
    '/api/translation', 
    { 
      params: { 
        populate: 'deep,4' 
      },
      headers: {
        'Authorization': `Bearer ${STRAPI_API_TOKEN}`
      }
    }
  );
  
  return data?.data;
};
